export default {
  TYPE: 'interested_topic', // 打 API type名稱
  SELECT_MINIMUM_LIMIT: 3, // 適性選擇最少3個
  SELECTED: 1, // 被選擇的適性狀態
};
